import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link, Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [msg, setMsg] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get('token');
    if (!token) { setStatus('error'); setMsg('Enlace inválido.'); return; }
    verifyEmail(token).then((res) => {
      if (res.success) setStatus('success');
      else { setStatus('error'); setMsg(res.error || 'El enlace expiró o no es válido.'); }
    });
  }, [params, verifyEmail]);

  if (status === 'success') return <Navigate to="/" replace />;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-base)', padding: '16px' }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: '32px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: 'var(--shadow-lg)' }}>
        {status === 'loading' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>⏳</div>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>Confirmando tu cuenta...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: '700', marginBottom: '8px' }}>No se pudo confirmar</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px', marginBottom: '20px' }}>{msg}</p>
            <Link to="/login" style={{ color: 'var(--accent-primary)', fontWeight: '600', fontSize: '13px', textDecoration: 'none' }}>← Volver al login</Link>
          </>
        )}
      </div>
    </div>
  );
}
